<template>
  <div class="vd-gl-content">
    <div>
      <a-icon type="info-circle" style="color: #40a9ff" />
      注意事项!
      <ul>
        <li>按地区选择 可以选中地市点击全部选中后创建推广用户</li>
        <li>最下面的表格中展示的是待创建的用户</li>
      </ul>
    </div>
    <a-form-model :label-col="labelCol">
      <a-form-model-item label="推广页面">
        <a-select
          style="width: 328px"
          v-model="form.pageId"
          placeholder="请选择推广页面"
        >
          <template v-if="promotionList.length > 0">
            <template v-for="item in promotionList">
              <a-select-option :value="item.id" :key="item.id">
                {{ item.remark }}
              </a-select-option>
            </template>
          </template>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="按地区选择">
        <!-- 联机选择器 -->
        <a-cascader
          style="width: 328px"
          :options="areaTree"
          :field-names="{
            label: 'name',
            value: 'id',
            children: 'children',
          }"
          placeholder="请选择用户所属地区"
          :change-on-select="true"
          @change="
            (e) => {
              this.selectPath = e
            }
          "
        />
        <!-- 搜索 -->
        <a-button style="margin-left: 32px" @click="selectAdmin">搜索</a-button>
      </a-form-model-item>

      <a-form-model-item label="成员列表" :label-col="labelCol">
        <div>
          <a-button size="small" @click="selectAll">
            全部选中 ({{ adminList.length }}个)</a-button
          >
          <a-button
            style="margin-left: 10px;"
            type="primary"
            size="small"
            @click="addMember"
          >
            创建 ({{ selectList.length }}个)
          </a-button>
          <a-button style="margin-left: 10px;" size="small" @click="onCancel">
            取消
          </a-button>
          <a-divider />
          <template v-if="adminList.length > 0">
            <div style="height: 120px;overflow-y: scroll;">
              <template v-for="item in adminList">
                <a-tag :key="item.id" @click="selectItem(item)">
                  {{ item.nickname }} ({{ item.username }}) -
                  {{ item.area_name }}
                </a-tag>
              </template>
            </div>
          </template>
          <template v-else>
            <a-empty :description="false" />
          </template>
        </div>
      </a-form-model-item>

      <a-table
        row-key="id"
        :data-source="selectList"
        :pagination="false"
        size="small"
        :scroll="{ y: 312 }"
        :locale="{ emptyText: '请选择推广成员' }"
      >
        <a-table-column title="姓名" data-index="nickname" />
        <a-table-column title="工号" data-index="username" />
        <a-table-column title="所属地区" data-index="area_name" />
        <a-table-column title="操作">
          <template slot-scope="record">
            <a-tag color="red" @click="removeAdmin(record.id)"> 移 除</a-tag>
          </template>
        </a-table-column>
      </a-table>
    </a-form-model>
  </div>
</template>
<script>
import { AdminByAreaApi } from '@/api'
import { getPromotionPage, add_active_member } from '@/api/program'
import { get_area_tree } from '@/api/auth'

export default {
  name: 'DetailAdd',
  data() {
    return {
      areaTree: [],
      selectPath: [],
      adminList: [],
      promotionList: [],
      selectList: [], // 选中的用户
      labelCol: { span: 4 },
      form: {
        table_pk: 0,
        name: '',
        code: '',
        uid: 0,
        pageId: undefined,
        task: 99,
        type: 0,
      },
    }
  },
  mounted() {
    this.id = parseInt(this.$route.query.id)
    // 获取管理地区信息
    get_area_tree().then((res) => {
      this.areaTree = res.code === 1 ? res.areaTree : []
    })
    // 获取推广页面数据
    getPromotionPage({
      active_id: this.id,
    }).then((res) => {
      this.promotionList = res.code === 1 ? res.list : []
    })
  },
  methods: {
    selectAdmin() {
      if (this.selectPath.length === 0) {
        this.$message.warning('请选择地区')
        return false
      }
      AdminByAreaApi({ area_path: this.selectPath }).then((res) => {
        if (res['code'] === 1) {
          // 该地区下的用户
          this.adminList = res['admin_list']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    // 选中全部搜索出来的数据
    selectAll() {
      // 当前的成员列表
      if (this.adminList.length <= 0) {
        this.$message.warning('请先按地区查询推广人')
        return false
      }
      this.adminList.forEach((item) => {
        this.selectItem(item)
      })
    },
    selectItem(item) {
      // 检测重复
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i]['id'] === item['id']) {
          this.$message.info({
            content: '重复添加用户已自动去除',
            key: 'unique_member',
          })
          return false
        }
      }
      this.selectList.push(item)
    },
    removeAdmin(selected) {
      this.selectList = this.selectList.filter((item) => {
        return item.id !== selected
      })
    },
    checkNum(value) {
      if (value > 1000) {
        this.form.task = 1000
      } else if (value < 1) {
        this.form.task = 1
      } else {
        this.form.task = value
      }
    },
    addMember() {
      this.confirmLoading = true
      if (undefined === this.form.pageId) {
        this.$message.warning('请选择推广页面')
        return false
      }
      if (this.selectList.length === 0) {
        this.$message.warning('缺少参数')
        return false
      }

      add_active_member({
        activeId: this.id,
        task: this.form.task,
        user: this.selectList,
        pageId: this.form.pageId,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
        } else {
          this.$message.warning(res.msg)
          setTimeout(() => {
            this.confirmLoading = false
          }, 2000)
        }
      })
    },
    onCancel() {},
  },
}
</script>

<style scoped></style>
